export default "__VITE_ASSET__94d4638d__"